module.exports = __webpack_public_path__ + "img/config.275963d6.png";